import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslatableContentState } from '@application/state';
import { translateText } from './translateText';

export interface UseTranslateStringParams {
  content?: string;
  format: 'text' | 'html';
}
export const useTranslateString = (params: UseTranslateStringParams) => {
  const { content, format } = params;

  const [translation, setTranslation] = useState<undefined | null | string>();
  const [loading, setLoading] = useState<boolean>(false);
  const { originalLanguage, targetLanguage } = useTranslatableContentState();

  const shouldTranslate = useMemo(() => {
    return targetLanguage !== undefined && originalLanguage !== targetLanguage;
  }, [originalLanguage, targetLanguage]);

  const handleTranslation = useCallback(async () => {
    setLoading(true);
    const result = await translateText({
      textToTranslate: content,
      targetLang: targetLanguage,
      format,
      originalLang: originalLanguage,
    });

    setTranslation(result ?? content);
    setLoading(false);
  }, [content, format, originalLanguage, targetLanguage]);

  useEffect(() => {
    if (!shouldTranslate) {
      setTranslation(undefined);
    } else {
      handleTranslation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldTranslate]);

  return { translation, loading };
};
